import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { OverlayTrigger, Icon } from "components/common";
const UnknownFieldTitleContainer = styled.div`
  display: flex;
  gap: 5px;
`;
const ErrorIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.warning};
  `
);
const UnknownAttributeTitle = () => {
  const { t } = useTranslation("widgets");
  return /* @__PURE__ */ React.createElement(UnknownFieldTitleContainer, null, t("events_widget.unknown_attribute"), /* @__PURE__ */ React.createElement(OverlayTrigger, { overlay: t("events_widget.unknown_attribute_help"), placement: "bottom" }, /* @__PURE__ */ React.createElement(ErrorIcon, { name: "error" })));
};
export default UnknownAttributeTitle;
